import React from 'react'
import { useSelector } from 'react-redux'
import { IStore } from '../../../store/types'
import { useAppDispatch } from '../../../store'
import { deleteTemplate } from '../../../store/templatesTechSupport/actions'
import { ListTamplates } from '../../../components/Templates/ListTamplates'

export const TechListTamplates: React.FC = () => {
  const { templatesTechSupport } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  const handleDelete = (id: number, calback?: () => void) => {
    dispatch(deleteTemplate(id)).then(calback)
  }

  return <ListTamplates groups={templatesTechSupport.groups} deleteTemplate={handleDelete} />
}
